// extracted by mini-css-extract-plugin
export default {"phtv_container":"index_phtv_container_P9N1p","phtv_wrap":"index_phtv_wrap_HFF1w","phtv_main":"index_phtv_main_sTCf8","phtv_title":"index_phtv_title_h63dW","spin":"index_spin_P6AU-"};